import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  jsonLd,
}: SEOProps) {
  const location = useLocation();

  useEffect(() => {
    const baseTitle = '吃瓜爆料 | 吃瓜爆料网入口-吃瓜爆料在线-吃瓜爆料第一站';
    const baseDescription = '吃瓜爆料官网入口导航，提供吃瓜爆料网、吃瓜爆料在线、吃瓜爆料第一站等官方主页与网站入口，支持快速登录，一站式直达最新爆料内容。';
    const baseKeywords = '吃瓜爆料,吃瓜爆料网,吃瓜爆料网站,吃瓜爆料网入口,吃瓜爆料在线,吃瓜爆料第一站,吃瓜爆料官网入口,吃瓜爆料登录,吃瓜爆料主页';

    document.title = title || baseTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description || baseDescription);
    setMeta('keywords', keywords || baseKeywords);
    setMeta('og:title', title || baseTitle, true);
    setMeta('og:description', description || baseDescription, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonicalUrl || `https://www.chiguabaoliao.com${location.pathname}`, true);
    setMeta('twitter:title', title || baseTitle);
    setMeta('twitter:description', description || baseDescription, true);

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', canonicalUrl || `https://www.chiguabaoliao.com${location.pathname}`);
    }
  }, [title, description, keywords, canonicalUrl, ogType, location.pathname]);

  useEffect(() => {
    if (!jsonLd) return;

    const existingScripts = document.querySelectorAll('script[data-seo-jsonld]');
    existingScripts.forEach((s) => s.remove());

    const items = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
    items.forEach((item) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo-jsonld', 'true');
      script.textContent = JSON.stringify(item, null, 2);
      document.head.appendChild(script);
    });

    return () => {
      const scripts = document.querySelectorAll('script[data-seo-jsonld]');
      scripts.forEach((s) => s.remove());
    };
  }, [jsonLd]);

  return null;
}